import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RemoveAttachmentsService {
  constructor(private http: HttpClient) {}

  deleteBatchDocuments(baseUrl: string, payload: any): Observable<any> {
    return this.http.post<any>(`${baseUrl}/removeAllBatchDocuments`, payload, {
      withCredentials: true,
    });
  }
}
